import './modules/epi-helpers';

(() => {
  const form = document.querySelector('.mailchimp-form');
  if (form === null) {
    return;
  }
  const formBtn = form.querySelector('.o-form__submit');
  const errDiv = form.querySelector('.Form__Errors');
  const errMsgDiv = form.querySelector('.Form__Errors .error-msg');
  const isErrDiv = errDiv && errMsgDiv;
  const origErrMsg = isErrDiv ? errMsgDiv.textContent : '';
  const displaySelector = 'hidden';
  // Temp reference fix for 'epiHelers'
  const formHelpers = window.epiHelpers;

  const validate = () => (
    formHelpers.validateForm() && formHelpers.validatePhoneIfExists()
  );

  const displayErrorMessage = (msg) => {
    formHelpers.reenableSubmitButton(formBtn);
    if (!isErrDiv) return;
    errMsgDiv.textContent = msg;
    errDiv.classList.remove(displaySelector);
  };

  const onFormSubmitSuccess = (data) => {
    // Mailchimp error will come through as a 200 from webservice
    // Need to check response for status:400, 500
    if (data.status !== undefined) {
      if (data.status !== 200) {
        displayErrorMessage(data.detail);
        return;
      }
    }
    if (data.Error !== undefined) {
      // The underlying connection was closed: An unexpected error occurred on a send
      displayErrorMessage(data.Error);
      return;
    }
    // Show confirmation & remove any error messages
    if (isErrDiv) {
      errDiv.classList.add(displaySelector);
    }
    const formMainBodyDiv = form.querySelector('.Form__MainBody');
    if (formMainBodyDiv) {
      formMainBodyDiv.classList.add(displaySelector);
    }
    const formConfirmationDiv = form.querySelector('.Form__Confirmation');
    if (formConfirmationDiv) {
      formConfirmationDiv.classList.remove(displaySelector);
    }
    // 10/10/2024 - Should be added as parameter instead of using window?
    if (window.onEpiFormSubmitSuccess) {
      window.onEpiFormSubmitSuccess();
    }
  };

  const onFormSubmitFail = () => (
    displayErrorMessage(origErrMsg)
  );

  formBtn.addEventListener('click', (event) => {
    event.preventDefault();
    formHelpers.disableSubmitButtonOnSend(formBtn);
    const options = {
      success: onFormSubmitSuccess,
      fail: onFormSubmitFail,
    };
    if (validate()) {
      formHelpers.sendLeadToMailchimp(options);
    } else {
      formHelpers.reenableSubmitButton(formBtn);
      formHelpers.scrollFormToFirstError();
    }
  });
})();
